import { normalizeCampPhone } from "./phone";

/** แปลงเบอร์ลาว → รูปแบบ wa.me (ไม่มี +) */
export function formatPhoneForWhatsApp(phone: string): string | null {
  const raw = normalizeCampPhone(phone);
  const digits = raw.replace(/\D/g, "");
  if (!digits) return null;

  if (digits.startsWith("856")) return digits;
  if (digits.startsWith("20")) return `856${digits}`;
  if (digits.startsWith("0")) return `856${digits.slice(1)}`;

  return digits.length >= 8 ? digits : null;
}

export function buildWhatsAppChatUrl(
  phone: string,
  message?: string,
): string | null {
  const waPhone = formatPhoneForWhatsApp(phone);
  if (!waPhone) return null;

  const base = `https://wa.me/${waPhone}`;
  const text = message?.trim();
  if (!text) return base;

  return `${base}?text=${encodeURIComponent(text)}`;
}

export function buildCampRegistrationWhatsAppUrl(input: {
  phoneNumber: string;
  fullName: string;
  nickname?: string;
  eventTitle?: string;
}): string | null {
  const displayName = input.nickname?.trim() || input.fullName.trim();
  const event = input.eventTitle?.trim() || "Summer Dance Camp 2026";
  const message = `ສະບາຍດີ ${displayName} — ທີມ Fanglao Studio ຕິດຕໍ່ກ່ຽວກັບ ${event}`;

  return buildWhatsAppChatUrl(input.phoneNumber, message);
}

export function buildCampWaitlistWhatsAppUrl(input: {
  phoneNumber: string;
  fullName: string;
  nickname?: string;
  className?: string;
  eventTitle?: string;
}): string | null {
  const displayName = input.nickname?.trim() || input.fullName.trim();
  const classLabel = input.className?.trim() || "ຄລາສ";
  const event = input.eventTitle?.trim() || "Summer Dance Camp 2026";
  const message = `ສະບາຍດີ ${displayName} — ມີທີ່ນັ່ງ ${classLabel} ${event} ແລ້ວ ກະລຸນາຕິດຕໍ່ກັບຄືນ`;

  return buildWhatsAppChatUrl(input.phoneNumber, message);
}
